// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"952c1a0f","814":"227d9b37"}[chunkId] + ".chunk.css";
};